export default __webpack_public_path__ + "static/media/playing.71393e90.png";